// Model
import PaymentMethodModel from "../model/payment-method.model";

export function mapperToPaymentMethodModel(paymentMethodDTO) {
    return new PaymentMethodModel(paymentMethodDTO.id, paymentMethodDTO.name)
}